import get from 'lodash/get';
import React from 'react';
import {getScheduleStatus} from '../domain/utils';
import {DateLabel} from '../enums/DateLabel';


export function getAccessors(type, task) {
  if (type === 'auto') {
    type = getAssignmentType(task);
  }

  switch (type) {
    case 'scheduled':
      return {
        timeLabel: DateLabel.byLabel,
        getIcon: getScheduleStatusIconClass,
        getDate: getScheduled,
        getUseTime: useScheduledTime,
        getTarget: getAssignedTo,
      };

    case 'submitted':
      return {
        timeLabel: DateLabel.atLabel,
        getIcon: getScheduleStatusIconClass,
        getDate: getSubmittedOn,
        getUseTime: showTime,
        getTarget: getSubmittedBy,
      };

    case 'approved':
      return {
        timeLabel: DateLabel.atLabel,
        getIcon: getScheduleStatusIconClass,
        getDate: getApprovedOn,
        getUseTime: showTime,
        getTarget: getApprovedBy,
      };

    case 'cancelled':
      return {
        timeLabel: DateLabel.atLabel,
        getIcon: getScheduleStatusIconClass,
        getDate: getCancelledOn,
        getUseTime: showTime,
        getTarget: getCancelledBy,
      };

    case 'rejected':
      return {
        timeLabel: DateLabel.atLabel,
        getIcon: getScheduleStatusIconClass,
        getDate: getRejectedOn,
        getUseTime: showTime,
        getTarget: getRejectedBy,
      };

    default:
      return {};
  }
}

// icons

function getScheduleStatusIconClass(task) {
  switch (getScheduleStatus(task)) {
    case 'not_scheduled':
      return 'swift-unscheduled';

    case 'scheduled':
      return 'swift-scheduled';

    case 'imminent':
      return 'swift-imminent';

    case 'past_due':
      return 'swift-overdue';

    case 'cancelled':
      return 'swift-schedule-cancelled';

    case 'complete':
      return 'swift-schedule-complete';
  }
}

// utils

export function getAssignmentType(model) {
  switch (model && model.status) {
    case 'submitted':
    case 'approved':
      return 'submitted';
    case 'cancelled':
      return 'cancelled';
    default:
      return 'scheduled';
  }
}

// Helper methods

function getAssignedTo(task) {
  return get(task, 'assignedTo');
}

function getSubmittedBy(task) {
  return get(task, 'submittedBy');
}

function getApprovedBy(task) {
  return get(task, 'approvedBy');
}

function getCancelledBy(task) {
  return get(task, 'cancelledBy');
}

function getRejectedBy(task) {
  return get(task, 'rejectedBy');
}

// get date

function getScheduled(task) {
  return get(task, 'scheduled', null);
}

function getSubmittedOn(task) {
  return get(task, 'submittedOn', null);
}

function getApprovedOn(task) {
  return get(task, 'approvedOn', null);
}

function getCancelledOn(task) {
  return get(task, 'cancelledOn', null);
}

function getRejectedOn(task) {
  return get(task, 'rejectedOn', null);
}

// display time part

function useScheduledTime(task) {
  return task && task.scheduled ? task.useTime : false;
}

function showTime() {
  return true;
}



// WEBPACK FOOTER //
// ./src/js/tasks/utils/index.js